import { render, staticRenderFns } from "./CalendarEventResponseTypeInvitee.vue?vue&type=template&id=28e41a4f&scoped=true&"
import script from "./CalendarEventResponseTypeInvitee.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventResponseTypeInvitee.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventResponseTypeInvitee.vue?vue&type=style&index=0&id=28e41a4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e41a4f",
  null
  
)

export default component.exports